<template>
  <BaseModal
    :is-visible="isVisible"
    @hideModal="hideModal()"
    :is-editable="false"
    :is-archivable="false"
    size="xl"
  >
    <template #header></template>
    <template #body>
      <Loader v-if="isLoading"></Loader>
      <object v-if="display && !isLoading" style="height: 80vh; width: 100%" :data="base64data"></object>
      <div class="btn-group">
        <button type="button" class="btn btn-warning btn-text-black" @click="downloadPDF()"> {{ $t('buttons.downloadPDF') }} </button>
        <button type="button" class="btn btn-default" @click="hideModal()"> {{ $t('buttons.cancel') }} </button>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import BaseModal from '@/components/BaseComponents/BaseModal'
import Loader from '@/components/Dashboard/Layout/Loader'

export default {
  name: 'InvoiceShowModal',
  components: {
    BaseModal,
    Loader
  },
  computed: {
    ...mapGetters({
      isVisible: 'exsbinvoice/showModal/isVisible',
      isLoading: 'exsbinvoice/showModal/isLoading',
      base64data: 'exsbinvoice/showModal/base64data',
      display: 'exsbinvoice/showModal/isFetchSuccessful'
    })
  },
  methods: {
    hideModal () {
      this.toggleModal()
      this.reset()
    },
    ...mapMutations({
      toggleModal: 'exsbinvoice/showModal/toggleModal',
      reset: 'exsbinvoice/showModal/reset'
    }),
    ...mapActions({
      downloadPDF: 'exsbinvoice/showModal/downloadPdf',
      fetchInvoiceAsPDF: 'exsbinvoice/showModal/fetchInvoiceAsPDF'
    })
  }
}
</script>

<style scoped>

</style>
